import {Download} from '@jobseeker/lotus/icons';
import {Box, BoxProps, Grid, GridProps, Typography} from '@mui/material';

interface SectionProps extends GridProps {
  heading: string;
  subHeading?: string;
  children: React.ReactNode;
  endEdornment?: React.ReactNode;
  endEdornmentProps?: BoxProps;
}

function Section(props: SectionProps) {
  const {heading, subHeading} = props;
  return (
    <Grid
      container
      {...props}
      sx={{
        // minHeight: '400px',
        maxWidth: '1048px',
        background: '#ffffff',
        borderRadius: '16px',
        padding: {
          xxs: 1,
          sm: 3,
        },
        py: {
          xxs: 2,
          sm: 3,
        },
        margin: 'auto auto',
        ...props.sx,
      }}
    >
      <Grid item xxs={12}>
        <Grid container justifyContent={'space-between'}>
          <Grid item xs={12} md={9}>
            <Typography fontSize={20} fontWeight={500}>
              {heading}
            </Typography>
            {subHeading?.length && (
              <Typography
                fontSize={12}
                fontWeight={500}
                mb={{xxs: 1, md: 1.75}}
              >
                {subHeading}
              </Typography>
            )}
          </Grid>
          {props.endEdornment}
        </Grid>
      </Grid>
      {props.children}
    </Grid>
  );
}

export default Section;
